import { Entity } from "@dinahmoe/dmafjs-core";

class UiStringsData extends Entity {
  namespace = "se26:uiStringsData";
}

const uiStringsData = new UiStringsData();
export { uiStringsData, UiStringsData };
